import React, { useEffect } from 'react';

import { InputAdornment, Stack, TextField } from '@mui/material';
import { Button, Icon } from 'semantic-ui-react';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from 'tss-react/mui';

import { OhsFormFieldBaseProps } from '../services/OhsFormModels';
import OhsFormFieldLayout from '../components/OhsFormFieldLayout';
import { returnFieldStyle, returnVariant } from '../components/OhsFieldLayout';
import { OhsMaterialIconButton } from '../../buttons/OhsMaterialButton';

const useStyles = makeStyles()(() => ({
  closeButton: {
    padding: 0,
    marginRight: '-2px',
  },
  closeIcon: {
    fontSize: '1.25em',
    opacity: 0.9,
  },
}));
function ColorPicker(props: any) {
  const { classes } = useStyles();
  const { setValue, register, trigger } = props.ohsFormSettings.useFormMethods;
  const currentColor = props.ohsFormSettings.useFormMethods.getValues(props.id);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as string;
    setValue(props.id, value);
  };

  useEffect(() => {
    register(props.id, {
      onChange: handleChange,
      validate: {
        notEmpty: (value: any) => {
          if (props.required === true) {
            if (value == null || (typeof value === 'string' ? value.trim() === '' : false)) {
              return false;
            }
          }

          return true;
        },
      },
    });
  }, [
    props.id,
    props.ohsFormSettings.useFormMethods,
    props.ohsFormSettings.useFormMethods.register,
    props.required,
  ]);

  const handleClear = () => {
    setValue(props.id, '');
    trigger(props.id);
  };

  return (
    <div data-testid={props.id}>
      {!currentColor ? (
        <Stack direction="row" spacing={1} alignItems="center">
          <Button
            data-testid={`${props.id}-button`}
            icon
            onClick={() => {
              setValue(props.id, '#000000');
              trigger(props.id);
            }}
            disabled={!!props.disabled}
          >
            <Icon name="pencil" />
          </Button>
          <p>No Colour Selected</p>
        </Stack>
      ) : (
        <Stack direction="row" spacing={1}>
          <TextField
            id={props.id}
            type="color"
            fullWidth
            multiline={props.type === 'textarea'}
            size="small"
            margin="dense"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              'data-testid': `${props.id}-field`,
              endAdornment: (
                <InputAdornment position="end">
                  <OhsMaterialIconButton
                    color="inherit"
                    onClick={handleClear}
                    size="small"
                    disabled={!!props.disabled}
                    className={classes.closeButton}
                  >
                    <CloseIcon className={classes.closeIcon} />
                  </OhsMaterialIconButton>
                </InputAdornment>
              ),
            }}
            placeholder={props.placeholder}
            variant={returnVariant(props.ohsFormSettings.layout)}
            required={props.required}
            disabled={props.disabled}
            value={currentColor}
            onChange={handleChange}
            style={returnFieldStyle(props.ohsFormSettings.layout)}
          />
        </Stack>
      )}
    </div>
  );
}

export default function OhsColorPicker(props: OhsFormFieldBaseProps) {
  return <OhsFormFieldLayout {...props} inputEle={<ColorPicker {...props} />} />;
}
